// Shared constants between frontend and backend

export const PROJECT_TYPES = {
  PERSONAL: 'personal',
  BUSINESS: 'business'
};

export const STEP_NAMES = {
  VISION: 'vision',
  SITUATION_ANALYSIS: 'situation_analysis',
  STRATEGIC_OBJECTIVES: 'strategic_objectives',
  ACTION_COMPONENTS: 'action_components',
  RESOURCES: 'resources',
  TIMELINE: 'timeline',
  RISKS: 'risks',
  GOVERNANCE: 'governance',
  PERFORMANCE: 'performance',
  ADAPTATION: 'adaptation'
};

export const STEP_LABELS = {
  [STEP_NAMES.VISION]: 'steps.vision',
  [STEP_NAMES.SITUATION_ANALYSIS]: 'steps.situation_analysis',
  [STEP_NAMES.STRATEGIC_OBJECTIVES]: 'steps.strategic_objectives',
  [STEP_NAMES.ACTION_COMPONENTS]: 'steps.action_components',
  [STEP_NAMES.RESOURCES]: 'steps.resources',
  [STEP_NAMES.TIMELINE]: 'steps.timeline',
  [STEP_NAMES.RISKS]: 'steps.risks',
  [STEP_NAMES.GOVERNANCE]: 'steps.governance',
  [STEP_NAMES.PERFORMANCE]: 'steps.performance',
  [STEP_NAMES.ADAPTATION]: 'steps.adaptation'
};

export const STEP_DESCRIPTIONS = {
  [STEP_NAMES.VISION]: 'stepDescriptions.vision',
  [STEP_NAMES.SITUATION_ANALYSIS]: 'stepDescriptions.situation_analysis',
  [STEP_NAMES.STRATEGIC_OBJECTIVES]: 'stepDescriptions.strategic_objectives',
  [STEP_NAMES.ACTION_COMPONENTS]: 'stepDescriptions.action_components',
  [STEP_NAMES.RESOURCES]: 'stepDescriptions.resources',
  [STEP_NAMES.TIMELINE]: 'stepDescriptions.timeline',
  [STEP_NAMES.RISKS]: 'stepDescriptions.risks',
  [STEP_NAMES.GOVERNANCE]: 'stepDescriptions.governance',
  [STEP_NAMES.PERFORMANCE]: 'stepDescriptions.performance',
  [STEP_NAMES.ADAPTATION]: 'stepDescriptions.adaptation'
};

export const COLORS = {
  PRIMARY: '#1E88E5',
  SECONDARY: '#FFC107',
  SUCCESS: '#4CAF50',
  WARNING: '#FF9800',
  ERROR: '#F44336',
  BACKGROUND: '#F5F5F5'
};
